export const FIND_AIRCRAFT_BASELINE = "FIND_AIRCRAFT_BASELINE";
export const FIND_AIRCRAFT_BASELINE_PENDING = "FIND_AIRCRAFT_BASELINE_PENDING";
export const FIND_AIRCRAFT_BASELINE_FULFILLED = "FIND_AIRCRAFT_BASELINE_FULFILLED";
export const FIND_AIRCRAFT_BASELINE_REJECTED = "FIND_AIRCRAFT_BASELINE_REJECTED";

export const RESET_AIRCRAFT_BASELINE = "RESET_AIRCRAFT_BASELINE";

export const AUTOFILL_CONFIGURATION = "AUTOFILL_CONFIGURATION";
export const AUTOFILL_CONFIGURATION_PENDING = "AUTOFILL_CONFIGURATION_PENDING";
export const AUTOFILL_CONFIGURATION_FULFILLED = "AUTOFILL_CONFIGURATION_FULFILLED";
export const AUTOFILL_CONFIGURATION_REJECTED = "AUTOFILL_CONFIGURATION_REJECTED";
